import { OfferSubCategory } from '../../../common/enums.js';
import { isProductSubcategory, normalizeProductSubcategory } from '../utils/productSubcategoryUtilsCoCo.js';
import type { ProductConfigDescriptor } from './productConfigTypesCoCo.js';
import type { ProductOfferingCartItems } from '../../../common/types/shoppingBasketCoCo.js';

const registry = new Map<string, ProductConfigDescriptor>();
const INSTALLATION_REQUIRED_METADATA_NAME = 'appointmentRequired';

export const registerProductConfig = (subcategory: string, descriptor: ProductConfigDescriptor): void => {
  registry.set(normalizeProductSubcategory(subcategory), descriptor);
};

export const getProductConfigDescriptor = (subcategory?: string): ProductConfigDescriptor | null =>
  registry.get(normalizeProductSubcategory(subcategory)) ?? null;

export const supportsInstallationAvailability = (subcategory?: string): boolean =>
  getProductConfigDescriptor(subcategory)?.supportsInstallationAvailability ?? false;

export const shouldShowInstallationDateSelection = (
  productOffering: Pick<ProductOfferingCartItems, 'productOfferingType' | 'planProductOffering'>
): boolean => {
  if (isProductSubcategory(productOffering.productOfferingType?.subcategory, OfferSubCategory.FIXED_BROADBAND)) {
    return true;
  }

  return (
    productOffering.planProductOffering?.metadata?.some(
      metadata =>
        metadata.name === INSTALLATION_REQUIRED_METADATA_NAME && metadata.value?.trim().toLowerCase() === 'true'
    ) ?? false
  );
};
